import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface InternalAuditRommsProps {
  onBack: () => void;
}

export default function InternalAuditRomms({ onBack }: InternalAuditRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} />;
}
